module.exports = __webpack_public_path__ + "img/numeralia_cedis_5otro.b5bf5ccd.webp";